import React, { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-datepicker/dist/react-datepicker.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import VisibilityIcon from '@material-ui/icons/Visibility';
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Pagination from '@material-ui/lab/Pagination';
import Icon from "@material-ui/core/Icon";

// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
import Table from "components/Table/Table.js";
import CardIcon from "components/Card/CardIcon.js";
import CardFooter from "components/Card/CardFooter.js";
import api from "assets/services/api.js";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import ModalUpdateSellsman from "components/ModalUpdateSellsman/ModalUpdateSellsman";
import ModalAddSellsman from "components/ModalAddSellsman/ModalAddSellsman";
import ModalDeleteSellsman from "components/ModalDeleteSellsman/ModalDeleteSellsman";
import ModalViewClientsOfSellsman from "components/ModalViewClientsOfSellsman/ModalViewClientsOfSellsman";
import useAuth from "hooks/useAuth";

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    colorCard: {
        color: "#999"
    },
    floatRight: {
        float: "right"
    },
    maxwidht: {
        maxWidth: "107%"
    },
    toogleclass: {
        marginTop: "14px",
        marginBottom: "14px",
        width: "65%",
    },
    backGreen: {
        backgroundColor: "#4caf50"
    },
    backRed: {
        backgroundColor: "rgb(244 67 54 / 1)"
    },
    zindex: {
        zIndex: "0 !important"
    },
    marginDate: {
        marginTop: "12px",
        marginBottom: "12px"
    }
};
const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);
export default function Sellsman() {
    const classes = useStyles();
    const classes2 = useStyles2();
    const { storageId, storageUserType } = useAuth();
    const [sellsmans, setSellsmans] = useState([]);

    const [search, setSearch] = useState("");
    const [totalPages, setTotalPages] = useState();
    const [page, setPage] = useState(1);

    const [modalShow, setModalShow] = useState(false);
    const [modalShowUpdate, setModalShowUpdate] = useState(false);
    const [modalShowDelete, setModalShowDelete] = useState(false);
    const [modalViewClients, setModalViewClients] = useState(false);
    const [index, setIndex] = useState({ id: 1 });

    useEffect(() => {
        getAllSellmans();
    }, []);
    useEffect(() => {
        getAllSellmans();
    }, [totalPages, page]);

    function callModal(index) {
        setIndex(index);
        setModalShowUpdate(true);
    };
    function callModalDelete(index) {
        setIndex(index);
        ; setModalShowDelete(true);
    }
    function callModalClients(index) {
        setIndex(index);
        setModalViewClients(true);
    };

    async function getAllSellmans() {
        // try {
        const response = await api.get(`/sellsman/view/${storageId}?type=${storageUserType}&enable=&page=${page}&perPage=6&search=${search}`);
        setSellsmans(response.data.sellsman);
        setTotalPages(response.data.totalPages);
    };

    const handleChange = (event, value) => {
        setPage(value);
    };

    function getSellsmanForTable() {
        let teste = [];
        for (let i = 0; i < sellsmans.length; i++) {
            teste[i] = [];
            teste[i].push(sellsmans[i].username);
            teste[i].push(sellsmans[i].name);
            teste[i].push(sellsmans[i].contact);
            teste[i].push(sellsmans[i].address);
            teste[i].push(
                <div className={classes2.tableActions}>
                    <CardIcon>
                        <Icon title={sellsmans[i].enable ? "Validado" : "Não validado"}>{sellsmans[i].enable ? "done" : "clear"}</Icon>
                    </CardIcon>
                </div>
            );
            teste[i].push(
                <div className={classes2.tableActions}>
                    <Tooltip id="tooltip-top" title="Ver clientes" placement="top" classes={{ tooltip: classes2.tooltip }} >
                        <IconButton aria-label="Edit" className={classes2.tableActionButton} onClick={() => callModalClients(sellsmans[i])} >
                            <VisibilityIcon className={classes2.tableActionButtonIcon + " " + classes2.view} />
                        </IconButton>
                    </Tooltip>
                </div>
            );
            teste[i].push(
                <div className={classes2.tableActions}>
                    <Tooltip id="tooltip-top" title="Ver clientes" placement="top" classes={{ tooltip: classes2.tooltip }} >
                        <IconButton aria-label="Edit" className={classes2.tableActionButton} onClick={() => callModal(sellsmans[i])} >
                            <Edit className={classes2.tableActionButtonIcon + " " + classes2.edit} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip id="tooltip-top-start" title="Deletar" placement="top" classes={{ tooltip: classes2.tooltip }} >
                        <IconButton aria-label="Close" className={classes2.tableActionButton} onClick={() => callModalDelete(sellsmans[i])} >
                            <Close
                                className={classes2.tableActionButtonIcon + " " + classes2.close} />
                        </IconButton>
                    </Tooltip>
                </div>
            );
        };
        return teste;
    };
    return (
        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <div className={classes.zindex}>
                        <CardHeader className="d-flex justify-content-center zindex" color="warning" stats icon>
                            <CardIcon color="success">
                                <Icon>content_copy</Icon>
                            </CardIcon>
                        </CardHeader>
                    </div>
                    <CardBody className="d-flex justify-content-center">
                        <p className={classes.colorCard}>Clique abaixo para adicionar um vendedor ao operador</p>
                    </CardBody>
                    <CardFooter className="d-flex justify-content-center" stats>
                        <Button color="success" className={classes.margintp + classes.maxwidht} onClick={() => setModalShow(true)}>
                            Adicionar Vendedor
                        </Button>
                    </CardFooter>
                </Card>
            </GridItem>
            <Card>
                <CardHeader className={classes.zindex} color={"primary"}>
                    <h4 className={classes.cardTitleWhite}>Vendedores destinados a operação</h4>
                    <p className={classes.cardCategoryWhite}></p>
                </CardHeader>
                <CardBody>
                    <Table
                        index={index}
                        tableHeaderColor="primary"
                        tableHead={["Usuário", "Nome", "Contato", "Endereço", "Clientes", "Ações"]}
                        tableData={getSellsmanForTable()}
                    />
                </CardBody>
            </Card>
            <ModalViewClientsOfSellsman key={String("View_" + index.id)} props={index} show={modalViewClients} onHide={() => setModalViewClients(false)} />
            <ModalAddSellsman key={String("Sll_" + index.id)} props={index} show={modalShow}
                onHide={() => setModalShow(false)} getAllSellmans={getAllSellmans} />
            <ModalUpdateSellsman key={String("Upd_" + index.id)} props={index} show={modalShowUpdate}
                onHide={() => setModalShowUpdate(false)} getAllSellmans={getAllSellmans} />
            <ModalDeleteSellsman key={String("del_" + index.id)} props={index} show={modalShowDelete}
                onHide={() => setModalShowDelete(false)} getAllSellmans={getAllSellmans} />
            <Pagination count={totalPages} page={page} onChange={handleChange} />
        </GridContainer>
    );
};
